import React from "react";
import { Link } from "react-router-dom";
import { L10n } from "@fidget/common/i18n";
import { Path } from "../../../models/router";
import styles from "./loginInstead.css";

export const LoginInstead: React.SFC<{}> = () => {
  return (
    <div className={styles["login-link-container"]}>
      <p>
        <L10n id={"signup.getStarted.alreadyUsing"} />
      </p>
      <Link to={Path.LOGIN} className={styles.button}>
        <L10n id={"signup.signin"} />
      </Link>
    </div>
  );
};
